var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmilie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#DD353F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.567 14c0 6.94-5.627 12.567-12.567 12.567S1.433 20.94 1.433 14 7.06 1.433 14 1.433 26.567 7.06 26.567 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.233 17.929A7.362 7.362 0 0 1 14 21.366a7.36 7.36 0 0 1-6.206-3.395M10.1 10.1a.867.867 0 1 1-1.734 0 .867.867 0 0 1 1.734 0zM19.633 10.1a.867.867 0 1 1-1.734 0 .867.867 0 0 1 1.734 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilie);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjREQzNTNGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxwYXRoIGQ9Ik0yNi41NjcgMTRjMCA2Ljk0LTUuNjI3IDEyLjU2Ny0xMi41NjcgMTIuNTY3UzEuNDMzIDIwLjk0IDEuNDMzIDE0IDcuMDYgMS40MzMgMTQgMS40MzMgMjYuNTY3IDcuMDYgMjYuNTY3IDE0eiIvPgogICAgICAgIDxwYXRoIGQ9Ik0yMC4yMzMgMTcuOTI5QTcuMzYyIDcuMzYyIDAgMCAxIDE0IDIxLjM2NmE3LjM2IDcuMzYgMCAwIDEtNi4yMDYtMy4zOTVNMTAuMSAxMC4xYS44NjcuODY3IDAgMSAxLTEuNzM0IDAgLjg2Ny44NjcgMCAwIDEgMS43MzQgMHpNMTkuNjMzIDEwLjFhLjg2Ny44NjcgMCAxIDEtMS43MzQgMCAuODY3Ljg2NyAwIDAgMSAxLjczNCAweiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };